<template>
  <div>
    <base-header class="header pb-8 pt-5 pt-lg-8">
      <!-- Mask -->
      <span class="mask bg-gradient-warning opacity-8"></span>
      <!-- Header container -->
      <div class="container-fluid">
        <div class="row">
          <div class="col-12 text-right mt-0 mt-md-4 mt-lg-0">
            <router-link
              :to="getReturnLink()"
              class="btn-link font-weight-normal text-white"
              ><i class="fas fa-chevron-left mr-1"></i> Voltar para listagem das
              startups</router-link
            >
          </div>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--7">
      <div class="row">
        <div class="col-lg-7">
          <card shadow type="secondary" class="text-center">
            <div class="card-profile-image">
              <img
                v-if="startup.logo"
                :src="startup.logo.url"
                class="card-image my-3"
                alt="..."
              />
            </div>
            <div class="card-body mt-9 py-0">
              <h2 class="card-title text-orange mb-1">
                {{ startup.name }}
              </h2>
              <div>
                <div class="h5 font-weight-300 mb-1">
                  <i class="ni ni-pin-3 mr-2"></i>{{ startup.city || "..." }},
                  {{ startup.state || "..." }}
                </div>
              </div>
              <p class="ml-2 text-sm mt-3">
                <i class="fas fa-quote-left mr-1"></i
                >{{ startup.one_sentence_pitch
                }}<i class="fas fa-quote-right ml-1"></i>
              </p>
              <hr class="my-4" />
              <div v-if="startup.subscription" class="text-left">
                <div>
                  <h6 class="heading-small text-muted mb-4">
                    Avaliação técnica
                  </h6>
                  <div class="col-12">
                    <h6 class="heading-small text-muted mb-4">
                      <i class="fab fa-youtube mr-1"></i> Pitch vídeo
                    </h6>
                    <div class="video-wrap">
                      <div
                        class="video-container"
                        v-if="
                          startup.subscription.startup_pitch_video_youtube_id
                        "
                      >
                        <iframe
                          v-if="startup.subscription"
                          :src="
                            getUrl(
                              startup.subscription
                                .startup_pitch_video_youtube_id
                            )
                          "
                          frameborder="0"
                          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                          allowfullscreen
                        >
                        </iframe>
                      </div>
                      <div class="text-center" v-else>
                        <badge type="info"> Pitch vídeo não fornecido </badge>
                      </div>
                    </div>
                  </div>

                  <hr class="my-4" />
                  <div class="col-12">
                    <div>
                      <h6 class="heading-small text-muted mb-4">
                        <i class="far fa-file-pdf mr-1"></i> Pitch deck
                        <a
                          v-if="
                            startup.subscription && startup.subscription.deck
                          "
                          :href="startup.subscription.deck.url"
                          target="_blank"
                          class="btn btn-sm btn-primary float-right"
                        >
                          <i class="fas fa-file-download"></i> Baixar
                        </a>
                      </h6>
                      <div class="row mt-3">
                        <div class="col-12 text-center">
                          <div
                            v-if="
                              startup.subscription && startup.subscription.deck
                            "
                          >
                            <pdf
                              style="
                                margin: 0 auto;
                                width: 90%;
                                max-width: 700px;
                              "
                              ref="startupDeck"
                              :src="startup.subscription.deck.url"
                              :page="deck.page"
                              @num-pages="deck.pageCount = $event"
                              @page-loaded="deck.currentPage = $event"
                            ></pdf>
                            <div class="text-center mt-2">
                              <base-button
                                :iconOnly="true"
                                icon="fa fa-chevron-left"
                                size="sm"
                                class="mr-0"
                                @click="previousPage()"
                                :disabled="this.deck.page <= 1"
                              ></base-button>
                              <span class="mx-3 text-sm"
                                >{{ deck.currentPage }} /
                                {{ deck.pageCount }}</span
                              >
                              <base-button
                                :iconOnly="true"
                                icon="fa fa-chevron-right"
                                size="sm"
                                class="mr-0"
                                @click="nextPage()"
                                :disabled="
                                  this.deck.page >= this.deck.pageCount
                                "
                              ></base-button>
                            </div>
                          </div>
                          <div v-else>
                            <badge type="info">
                              Pitch deck não fornecido
                            </badge>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      v-if="startup.subscription && startup.subscription.note"
                    >
                      <hr class="my-4" />
                      <h6 class="heading-small text-muted mb-4">
                        <i class="fas fa-comment-dots mr-1"></i> Breves
                        Considerações
                        <span class="text-warning">Stars</span>
                      </h6>
                      <div class="ml-3 ai-container-read-only">
                        <quill-editor
                          v-model="
                            startup.subscription.note.considerations_stars
                          "
                          :options="editorReadOnly"
                          disabled="disabled"
                        >
                        </quill-editor>
                      </div>
                    </div>
                  </div>
                </div>
                <hr class="my-4" />
                <div>
                  <h6 class="heading-small text-muted mb-4">Sobre a startup</h6>
                  <p class="text-sm">
                    <i class="fas fa-arrow-right"></i> Setor(es) econômico(s) de
                    atuação:
                    <span class="text-muted">
                      {{ startup.sector }}
                    </span>
                  </p>
                  <p class="text-sm">
                    <i class="fas fa-arrow-right"></i> Data de fundação:
                    <span class="text-muted">
                      {{ formatDate(startup.foundation) }}
                    </span>
                  </p>
                  <p class="text-sm">
                    <i class="fas fa-arrow-right"></i> Estágio de maturidade
                    atual:
                    <span class="text-muted">
                      {{ stages[startup.stage] || startup.stage }}
                    </span>
                  </p>
                  <p class="text-sm">
                    <i class="fas fa-arrow-right"></i> Mercado principal de
                    atuação:
                    <span class="text-muted">
                      {{ startup.bussiness_strategy }}
                    </span>
                  </p>
                  <div class="mb-3" v-if="startup.subscription.startup_problem">
                    <p class="text-sm mb-1">
                      <i class="fas fa-arrow-right"></i> Desafios mais
                      significativos:
                      <span class="text-sm text-muted">
                        {{ startup.subscription.startup_problem }}
                      </span>
                    </p>
                  </div>
                  <div
                    class="mb-3"
                    v-if="startup.subscription.how_can_stars_help"
                  >
                    <p class="text-sm mb-1">
                      <i class="fas fa-arrow-right"></i> Como a Stars pode
                      ajudar?
                      <span class="text-sm text-muted">
                        {{ startup.subscription.how_can_stars_help }}
                      </span>
                    </p>
                  </div>
                  <div
                    class="mb-3"
                    v-if="startup.subscription.responsible_name"
                  >
                    <p class="text-sm mb-1">
                      <i class="fas fa-user-tie mr-1"></i>Nome do responsável:
                      <span class="text-sm text-muted">
                        {{ startup.subscription.responsible_name }}
                      </span>
                    </p>
                  </div>
                  <div
                    class="mb-3"
                    v-if="startup.subscription.responsible_phone"
                  >
                    <p class="text-sm mb-1">
                      <i class="fas fa-arrow-right"></i> Celular do responsável:
                      <span class="text-sm text-muted">
                        {{ startup.subscription.responsible_phone }}
                      </span>
                    </p>
                  </div>
                  <div
                    class="mb-3"
                    v-if="startup.subscription.responsible_email"
                  >
                    <p class="text-sm mb-1">
                      <i class="fas fa-arrow-right"></i> E-mail do responsável:
                      <span class="text-sm text-muted">
                        {{ startup.subscription.responsible_email }}
                      </span>
                    </p>
                  </div>
                  <p
                    class="text-sm"
                    v-if="startup.subscription.already_participated_batch"
                  >
                    <i class="fas fa-arrow-right"></i> Já participou de outro
                    Batch Stars?
                    <span class="text-muted">
                      {{ startup.subscription.already_participated_batch }}
                    </span>
                  </p>
                  <div v-if="startup.how_meet_stars" class="mb-3">
                    <p class="text-sm">
                      <i class="fas fa-arrow-right"></i> Como conheceu a Stars?
                      <span class="text-muted">
                        {{ startup.how_meet_stars }}
                      </span>
                    </p>
                  </div>
                </div>
                <hr class="my-4" />
                <div>
                  <h6 class="heading-small text-muted mb-4">Negócio</h6>
                  <p class="text-sm">
                    <i class="fas fa-arrow-right"></i> Maior vantagem
                    competitiva:
                    <span class="text-muted">
                      {{ startup.subscription.product_competitive_advantage }}
                    </span>
                  </p>
                  <p class="text-sm">
                    <i class="fas fa-arrow-right"></i> Modelo de negócios:
                    <span class="text-muted">
                      {{ startup.subscription.product_bussiness_strategy }}
                    </span>
                  </p>
                  <p
                    class="text-sm"
                    v-if="startup.subscription.last_year_revenue"
                  >
                    <i class="fas fa-arrow-right"></i> Faturamento total do
                    último ano (em reais):
                    <span class="text-muted" style="white-space: pre-line">
                      {{ startup.subscription.last_year_revenue }}
                    </span>
                  </p>
                  <p class="text-sm">
                    <i class="fas fa-arrow-right"></i> Faturamento total do
                    último trimestre (em reais):
                    <span class="text-muted" style="white-space: pre-line">
                      {{ startup.subscription.last_quarters_revenue }}
                    </span>
                  </p>
                  <div
                    class="mb-3"
                    v-if="
                      startup.subscription &&
                      startup.subscription.product_market_cap
                    "
                  >
                    <p class="text-sm mb-1">
                      <i class="fas fa-arrow-right"></i> Qual o tamanho de
                      mercado? (opcional)
                      <span class="text-sm text-muted">
                        {{ startup.subscription.product_market_cap }}
                      </span>
                    </p>
                  </div>
                  <div
                    class="mb-3"
                    v-if="
                      startup.subscription &&
                      startup.subscription.active_clients
                    "
                  >
                    <p class="text-sm mb-1">
                      <i class="fas fa-arrow-right"></i> Quantos clientes ativos
                      a startup possui atualmente?
                      <span class="text-sm text-muted">
                        {{ startup.subscription.active_clients }}
                      </span>
                    </p>
                  </div>
                  <div
                    class="mb-3"
                    v-if="
                      startup.subscription &&
                      startup.subscription.investment_sought
                    "
                  >
                    <p class="text-sm mb-1">
                      <i class="fas fa-arrow-right"></i> Qual o valor de
                      investimento que a startup busca?
                      <span class="text-sm text-muted">
                        {{ startup.subscription.investment_sought }}
                      </span>
                    </p>
                  </div>
                  <div
                    class="mb-3"
                    v-if="
                      startup.subscription &&
                      startup.subscription.equity_offered
                    "
                  >
                    <p class="text-sm mb-1">
                      <i class="fas fa-arrow-right"></i> Qual o percentual de
                      equity oferecido? (máximo de 100%)
                      <span class="text-sm text-muted">
                        {{ startup.subscription.equity_offered }}%
                      </span>
                    </p>
                  </div>
                  <p class="text-sm" v-if="startup.subscription.last_month_revenue">
                    <i class="fas fa-arrow-right"></i> Faturamento total do
                    último mês (em reais):
                    <span class="text-muted" style="white-space: pre-line">
                      {{ startup.subscription.last_month_revenue }}
                    </span>
                  </p>
                  <p class="text-sm">
                    <i class="fas fa-arrow-right"></i> Problema ou necessidade
                    resolvida pela empresa:
                    <span class="text-muted" style="white-space: pre-line">
                      {{ startup.subscription.product_market_problem }}
                    </span>
                  </p>
                  <p class="text-sm">
                    <i class="fas fa-arrow-right"></i> Captable atual:
                    <span class="text-muted" style="white-space: pre-line">
                      {{ startup.subscription.startup_equity }}
                    </span>
                  </p>
                  <p class="text-sm mb-1">
                    <i class="fas fa-arrow-right"></i> Website:
                    <span class="text-muted text-sm mb-0">
                      {{ getWebsiteUrl() }}
                    </span>
                  </p>
                </div>
              </div>
            </div>
          </card>
        </div>
        <div class="col-lg-5 mt-lg-0 mt-3">
          <card shadow type="secondary">
            <div slot="header" class="bg-white border-0">
              <div class="row align-items-center">
                <div class="col-8">
                  <h3 class="mb-0">Painel de avaliação</h3>
                </div>
              </div>
            </div>
            <div>
              <div
                class="row"
                v-for="(question, index) in evaluation.evaluationQuestions"
                :key="index"
              >
                <div class="col-md-8">
                  <h4>{{ index + 1 }}. {{ question.title }}</h4>
                  <p>{{ question.description }}</p>
                </div>
                <div class="col-md-4">
                  <div class="estrelas">
                    <input
                      type="radio"
                      :id="'star_0_question_' + question.id"
                      :name="'response_question_' + question.id"
                      value="0"
                      checked
                    />
                    <label :for="'star_1_question_' + question.id"
                      ><i class="fa"></i
                    ></label>
                    <input
                      type="radio"
                      :id="'star_1_question_' + question.id"
                      :name="'response_question_' + question.id"
                      :value="1"
                      v-model="model.answers[question.id]"
                    />
                    <label :for="'star_2_question_' + question.id"
                      ><i class="fa"></i
                    ></label>
                    <input
                      type="radio"
                      :id="'star_2_question_' + question.id"
                      :name="'response_question_' + question.id"
                      :value="2"
                      v-model="model.answers[question.id]"
                    />
                    <label :for="'star_3_question_' + question.id"
                      ><i class="fa"></i
                    ></label>
                    <input
                      type="radio"
                      :id="'star_3_question_' + question.id"
                      :name="'response_question_' + question.id"
                      :value="3"
                      v-model="model.answers[question.id]"
                    />
                    <label :for="'star_4_question_' + question.id"
                      ><i class="fa"></i
                    ></label>
                    <input
                      type="radio"
                      :id="'star_4_question_' + question.id"
                      :name="'response_question_' + question.id"
                      :value="4"
                      v-model="model.answers[question.id]"
                    />
                    <label :for="'star_5_question_' + question.id"
                      ><i class="fa"></i
                    ></label>
                    <input
                      type="radio"
                      :id="'star_5_question_' + question.id"
                      :name="'response_question_' + question.id"
                      :value="5"
                      v-model="model.answers[question.id]"
                    />
                  </div>
                </div>
              </div>
            </div>
            <hr class="my-4" />
            <div class="mb-4">
              <span class="form-control-label mr-3"
                >Você indicaria este investimento?</span
              >
              <div class="form-check form-check-inline mr-4">
                <input
                  class="form-check-input"
                  type="radio"
                  name="radioAdviseInvestiment"
                  id="neutroAdviseInvestimentRadio"
                  :value="null"
                  v-model="model.advise_investiment"
                />
                <label
                  class="form-check-label"
                  for="neutroAdviseInvestimentRadio"
                  >Neutro</label
                >
              </div>
              <div class="form-check form-check-inline mr-4">
                <input
                  class="form-check-input"
                  type="radio"
                  name="radioAdviseInvestiment"
                  id="notAdviseInvestimetRadio"
                  :value="false"
                  v-model="model.advise_investiment"
                />
                <label class="form-check-label" for="notAdviseInvestimetRadio"
                  >Não</label
                >
              </div>
              <div class="form-check form-check-inline">
                <input
                  class="form-check-input"
                  type="radio"
                  name="radioAdviseInvestiment"
                  id="adviseInvestimetRadio"
                  :value="true"
                  v-model="model.advise_investiment"
                />
                <label class="form-check-label" for="adviseInvestimetRadio"
                  >Sim</label
                >
              </div>
            </div>
            <hr class="my-4" />
            <div>
              <base-input label="Algum comentário? (opcional)">
                <textarea
                  rows="2"
                  v-model="model.comment"
                  class="form-control"
                  placeholder="Digite aqui..."
                >
                </textarea>
              </base-input>
            </div>
            <div class="text-center">
              <base-alert v-if="error" type="danger" class="text-center">{{
                error
              }}</base-alert>
              <base-button type="warning" :custom="true" @click="handleSubmit">
                <span v-if="!isUpdate">Avaliar startup</span>
                <span v-else>Atualizar avaliação</span>
              </base-button>
            </div>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

import { quillEditor } from "vue-quill-editor";
import api from "@/services/api.js";
import pdf from "vue-pdf";

export default {
  name: "avaliacao",
  components: {
    pdf,
    quillEditor,
  },
  data() {
    return {
      model: {
        answers: {},
        advise_investiment: null,
        comment: "",
      },
      isUpdate: false,
      startup: "",
      evaluation: "",
      error: "",
      editorReadOnly: {
        placeholder: "...",
        readOnly: true,
        theme: "bubble",
      },
      deck: {
        page: 1,
        currentPage: 0,
        pageCount: 0,
      },
      stages: {
        concept: "Ideação",
        validation: "Validação",
        traction: "Tração",
        scale: "Escala",
        other: "Outro",
      },
    };
  },
  async mounted() {
    const loader = this.$loading.show({
      container: this.$refs.form_edit_container,
      width: 140,
      height: 140,
    });
    await this.loadSubscription();
    await this.loadEvaluation();
    loader.hide();
  },
  methods: {
    getWebsiteUrl() {
      if (
        !this.startup.subscription ||
        !this.startup.subscription.product_more_information
      ) {
        return "não informado";
      }

      const productInfo = this.startup.subscription.product_more_information;

      if (Array.isArray(productInfo)) {
        const firstItem = productInfo[0];
        if (!firstItem || firstItem === "" || firstItem === "undefined") {
          return "não informado";
        }
        return firstItem;
      }

      if (typeof productInfo === "string") {
        try {
          const parsed = JSON.parse(productInfo);
          if (parsed && parsed.link && parsed.link.trim() !== "") {
            return parsed.link;
          }
          return "não informado";
        } catch (e) {
          return productInfo && productInfo.trim() !== ""
            ? productInfo
            : "não informado";
        }
      }

      return "não informado";
    },
    async loadSubscription() {
      try {
        const {
          data: { evaluation, startup },
        } = await api.get(
          `/investor-evaluations/${this.$route.params.idEvaluation}/subscriptions/${this.$route.params.idSubscription}`
        );
        const defaultLogoPath = "/img/pages/default_logo.png";
        if (!evaluation || !startup) {
          this.$toasted.error(
            "Ocorreu um erro ao recurperar a startup para avaliação"
          );
          this.$router.push("/investidor/avaliacoes");
        }
        if (!startup.logo) startup.logo = { url: defaultLogoPath };
        try {
          const links = JSON.parse(
            startup.subscription.product_more_information
          );
          if (Array.isArray(links)) {
          startup.subscription.product_more_information = links
            .map((link) => (link && link.link ? link.link : ""))
            .filter((link) => link && link.trim() !== "");
        } else if (links && links.link) {
          startup.subscription.product_more_information = [links.link];
        } else {
          startup.subscription.product_more_information = [];
        }
      } catch (e) {
        startup.subscription.product_more_information =
          startup.subscription.product_more_information &&
          startup.subscription.product_more_information.trim() !== ""
            ? [startup.subscription.product_more_information]
            : [];
        }
        this.evaluation = evaluation;
        this.startup = startup;

        evaluation.evaluationQuestions.forEach((question) => {
          this.model.answers[question.id] = 0;
        });
        this.model.subscription_id = this.$route.params.idSubscription;
        return;
      } catch (e) {
        this.$toasted.error("Ocorreu um erro ao recuperar as informações");
        this.$router.push(
          `/investidor/avaliacoes/${this.$route.params.idEvaluation}/startups`
        );
      }
    },
    async loadEvaluation() {
      try {
        const { data } = await api.get(
          `/investor-evaluations/${this.$route.params.idEvaluation}/responses/${this.$route.params.idSubscription}`
        );
        if (data) {
          this.isUpdate = true;
          this.evaluationResponseId = data.id;
          this.model.advise_investiment =
            data.advise_investiment === null
              ? null
              : Boolean(data.advise_investiment);
          this.model.comment = data.comment;
          data.answers.forEach((answer) => {
            if (this.model.answers[answer.question_id] === 0)
              this.model.answers[answer.question_id] = answer.stars;
          });
        }
      } catch (e) {
        this.error = "Ocorreu um erro ao recuperar as informações";
        this.$toasted.error("Ocorreu um erro ao recuperar as informações");
        this.$router.push(
          `/investidor/avaliacoes/${this.$route.params.idEvaluation}/startups`
        );
      }
    },
    async handleSubmit() {
      this.error = "";
      if (!this.isValidModel()) {
        this.error =
          "Por favor, complete a ficha avaliação antes de continuar.";
        return;
      }
      try {
        const url = `/investor-evaluations/${this.$route.params.idEvaluation}/responses`;
        if (!this.isUpdate) {
          await api.post(url, this.model);
        } else {
          await api.put(`${url}/${this.evaluationResponseId}`, this.model);
        }
        this.$toasted.show(
          `Avaliação ${this.isUpdate ? "salva" : "atualizada"} com sucesso`
        );
        this.$router.push(this.getReturnLink());
      } catch (e) {
        this.error = `Ocorreu um erro ao ${
          this.isUpdate ? "salvar" : "atualizar"
        } a avaliação. Tente novamente.`;
        this.$toasted.error(
          `Ocorreu um erro ao ${
            this.isUpdate ? "salvar" : "atualizar"
          } a avaliação`
        );
      }
    },
    isValidModel() {
      if (this.model.advise_investiment !== null || this.model.comment)
        return true;
      const answers = this.model.answers;
      for (let answer in answers) {
        if (answers[answer] !== 0) return true;
      }
      return false;
    },
    getUrl(youtubeVideoId) {
      return `https://www.youtube.com/embed/${youtubeVideoId}`;
    },
    nextPage() {
      if (this.deck.pageCount > this.deck.page) this.deck.page++;
    },
    previousPage() {
      if (this.deck.page > 1) this.deck.page--;
    },
    getReturnLink() {
      const { cb, scrollX, scrollY } = this.$route.query;
      let returnLink = `/investidor/avaliacoes/${
        this.$route.params.idEvaluation
      }/startups?grupo=${cb ? cb : "g1"}`;

      if (scrollX) returnLink += `&scrollX=${scrollX}`;
      if (scrollY) returnLink += `&scrollY=${scrollY}`;

      return returnLink;
    },
  },
};
</script>
<style scoped>
.card-image {
  width: 180px;
  height: 180px;
  border-radius: 10%;
  margin: auto;
}

.estrelas {
  text-align: right;
  margin-top: 2px;
  margin-right: 3%;
}

.estrelas input[type="radio"] {
  display: none;
}

.estrelas label i.fa:before {
  content: "\f005";
  color: #ff4200;
  font-size: 1.8em;
}

.estrelas input[type="radio"]:checked ~ label i.fa:before {
  color: #ccc;
}

.video-container {
  position: relative;
  overflow: hidden;
  height: 0;
  padding-bottom: 50%;
}

.video-container iframe,
.video-container embed {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  max-width: 100%;
}

.video-wrap {
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
}
</style>
<style>
.ai-container-read-only .quill-editor .ql-container,
.ai-container-read-only .quill-editor .ql-container .ql-editor {
  min-height: 5rem;
  max-height: 13rem;
  width: 100%;
}

p > strong {
  font-weight: bold !important;
}
</style>
